import { Navigate, useRoutes } from 'react-router-dom';
// config
import { PATH_AFTER_LOGIN, PATH_AFTER_LOGIN_DEVICE_ONLY, PATH_AFTER_LOGIN_IFTA_ONLY, PATH_AFTER_LOGIN_ELD_ONLY, PATH_AFTER_LOGIN_RENTALS_ONLY, PATH_AFTER_LOGIN_IS_PARENT } from 'src/config-global';
//
import CompactLayout from 'src/layouts/compact/layout';
import { useAuthContext } from 'src/auth/hooks';
import HowToUseDriver from 'src/pages/support/how-to-use-driver';
import Page404 from 'src/pages/404';
import UserInactivePage from 'src/pages/user-inactive';
import { mainRoutes } from './main';

import { authRoutes } from './auth';
import { appRoutes } from './app';

// ----------------------------------------------------------------------

export default function Router() {
  const { session } = useAuthContext();

  let pathAFterLogin: string;
  if (session?.organization?.rentalsOnly) {
    pathAFterLogin = PATH_AFTER_LOGIN_RENTALS_ONLY;
  } else if (session?.organization?.isParent) {
    pathAFterLogin = PATH_AFTER_LOGIN_IS_PARENT;
  } else if (session?.organization?.eldOnly) {
    pathAFterLogin = PATH_AFTER_LOGIN_ELD_ONLY;
  } else if (session?.organization?.deviceOnly){
    pathAFterLogin = PATH_AFTER_LOGIN_DEVICE_ONLY;
  } else if (session?.organization?.iftaOnly) {
    pathAFterLogin = PATH_AFTER_LOGIN_IFTA_ONLY
  } else {
    pathAFterLogin = PATH_AFTER_LOGIN;
  }



  return useRoutes([
    {
      path: '/',
      // eslint-disable-next-line no-nested-ternary
      element: <Navigate to={pathAFterLogin} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...appRoutes,

    // Main routes
    ...mainRoutes,

    {
      path: '/how-to-use-driver/:lang',
      element: <HowToUseDriver />,
    },

    {
      path: "user-inactive",
      element: <UserInactivePage />
    },

    // No match 404
    { path: '*', element: <CompactLayout><Page404 /></CompactLayout> },
  ]);
}
